import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
export const InvoiceEditorGrid = styled(Grid)({
  maxWidth: '100%',
  maxHeight: '100%',
  width: '85vw',
});

export const EditorGrid = styled(Grid)({
  maxWidth: '100%',
  maxHeight: '100%',
  height: '85vh',
  overflowY: 'auto',
});

export const PreviewGrid = styled(Grid)({
  maxWidth: '100%',
  maxHeight: '100%',
  height: '85vh',
});
